import React from 'react';
import { useSelector } from 'react-redux';
import { reportDetailViewSelector } from '../../features/datacenter/reportSlice';

import ReportDetailHeader from './ReportDetailHeader';
import DriveAndStop from './reportTemplates/DriveAndStop';
import GeneralInformation from './reportTemplates/GeneralInformation';
import BinarySensor from './reportTemplates/BinarySensor';
import ZoneReport from './reportTemplates/ZoneReport';
import Overspeed from './reportTemplates/Overspeed';
import TemperatureLog from './reportTemplates/TemperatureLog';
import FuelFillnTheft from './reportTemplates/FuelFillnTheft';
import FuelConsumption from './reportTemplates/FuelConsumption';
import DriveAndStopFuel from './reportTemplates/DriveAndStopFuel';
import FuelHighBurn from './reportTemplates/FuelHighBurn';
import FuelActivity from './reportTemplates/FuelActivity';
import FuelActivityAdvanced from './reportTemplates/FuelActivityAdvanced';
import FuelSummary from './reportTemplates/FuelSummary';
import TripFuel from './reportTemplates/TripFuel';
import TripViolation from './reportTemplates/TripViolation';
import TripLog from './reportTemplates/TripLog';
import GeneratorFleet from './reportTemplates/GeneratorFleet';
import TravelPath from './reportTemplates/TravelPath';
import GensetTamper from './reportTemplates/GensetTamper';

const ReportDetailView = () => {
    const reportDetailView = useSelector(reportDetailViewSelector);
    const reportData = useSelector(state => state.reports.reportData[reportDetailView]);

    const selectTemplate = () => {
        switch (reportData.reportType) {
            case "driveandstop":
                return <DriveAndStop reportData={reportData} />
            case "generalinformation":
                return <GeneralInformation reportData={reportData} />
            case "binarysensor":
                return <BinarySensor reportData={reportData} />
            case "zone":
                return <ZoneReport reportData={reportData} />
            case "tempbasic":
                return <TemperatureLog reportData={reportData} />
            case "temprange":
                return <TemperatureLog reportData={reportData} />
            case "overspeed":
                return <Overspeed reportData={reportData} />
            case "fuelfillntheft":
                return <FuelFillnTheft reportData={reportData} />
            case "fuelconsumption":
                return <FuelConsumption reportData={reportData} />
            case "driveandstopfuel":
                return <DriveAndStopFuel reportData={reportData} />
            case "fuelhighburn":
                return <FuelHighBurn reportData={reportData} />
            case "fuelactivity":
                return <FuelActivity reportData={reportData} />
            case "fuelsummary":
                return <FuelSummary reportData={reportData} />
            case "shinytripfuel":
                return <TripFuel reportData={reportData} />
            case "fuelactivityadvanced":
                return <FuelActivityAdvanced reportData={reportData} />
            case "tripviolations":
                return <TripViolation reportData={reportData} />
            case "triplog":
                return <TripLog reportData={reportData} />
            case "genfleet":
                return <GeneratorFleet reportData={reportData} />
            case "travel_path":
                return <TravelPath reportData={reportData} />
            case "genset_tamper":
                return <GensetTamper reportData={reportData} />
            default:
                return null;
        }
    }

    if (!reportDetailView || !reportData) {
        return null;
    } else {
        return (
            <div>
                <ReportDetailHeader reportData={reportData} />
                {selectTemplate()}
            </div>
        );
    }
}

export default ReportDetailView;
